import * as React from 'react';

const SvgSearch = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6999 14L10.862 11.1M12.3951 7.33333C12.3951 10.2789 10.0585 12.6667 7.17608 12.6667C4.29368 12.6667 1.95703 10.2789 1.95703 7.33333C1.95703 4.38781 4.29368 2 7.17608 2C10.0585 2 12.3951 4.38781 12.3951 7.33333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgSearch;
